import { PanelBar, PanelBarItem, PanelBarSelectEventArguments } from '@progress/kendo-react-layout';
import React, { useEffect, useRef, useState } from 'react'
import { Api } from '../../../redux/api/BaseApi';
import { TicketApi } from '../../../redux/api/TicketApi';
import { useReduxDispatch, useReduxSelector } from '../../../redux/hooks';
import CustomFormControl from '../../CustomForms/CustomForm';
import * as TicketSlice from '../../../slices/TicketSlice';
import UserFynd from '../ListControls/UserFynd';
import { IFyndResult } from '../../../types/IFyndResult';
import SLAList from '../ListControls/SLAList';
import StatusList from '../ListControls/StatusList';
import './TicketDetails.scss'
import ProjectList from '../../Project/ListControls/ProjectList';
import { IProject } from '../../../types/Project/IProject';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import PriorityList from '../ListControls/PriorityList';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AssociatedContacts from '../ListControls/AssociatedContacts';
import TeamList from '../ListControls/TeamList';
import AssignedStaff from '../ListControls/AssignedStaff';
import TypeList from '../ListControls/TypeList';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { IStaff } from '../../../types/IStaff';
import { PartialSpinny } from '../../Nav/Spinny';
import { UserApi } from '../../../redux/api/UserApi';
import validateCustomFields from '../../CustomForms/Validators/CustomFieldValidator';
import { TicketDetailProps } from '../../../types/Props/TicketDetailProps';
import { ITicket } from '../../../types/Ticket/ITicket';
import TicketSavedDialog from '../TicketSavedDialog';
import { TicketSavedDialogProps } from '../../../types/Props/TicketSavedProps';
import ActionNote from "../../Action/ActionNote/ActionNote"
import { ClientTypeFilter } from '../../ClientType/ClientTypeFilter';
import { ITemplateListItem } from '../../../types/Ticket/ITemplate';
import * as ActionSlice from '../../../slices/ActionSlice';
import BulkContacts from '../ListControls/BulkContacts';
import { //DESCRIPTION_LOWERCASE,
    TicketDescription
} from './TicketDescription/TicketDescription';
import JsonTreeViewer from '../../Test/JsonTreeViewer';
import TicketWorkstream from '../../Gameplan/TicketWorkstream';
import WorkstreamAssignment from '../../Gameplan/WorkstreamAssignment';
import FlaggedNotes from '../FormControls/FlaggedNotes/FlaggedNotes';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { IClient } from '../../../types/Client/IClient';
import TimelineImage from '../TimelineImage';
import { Label } from "@progress/kendo-react-labels";
import * as FileSlice from '../../../slices/FileSlice';
import { ProjectApi } from '../../../redux/api/ProjectApi';
import { parse } from 'path';

const SECTION_REQUIRED = "section-required";

const NewTicketDetails: React.FC<TicketDetailProps> = (props) => {
    const [confirmDialogProps, setConfirmDialogProps] = useState({ visible: false } as TicketSavedDialogProps)
    const { Id: ticketId } = useParams()
    const [searchParams] = useSearchParams();
    const debug = searchParams.get("debug")
    const templateId = searchParams.get("templateId")
    const endUserUId = searchParams.get("endUserId")
    const parentCallId = searchParams.get("parentCallId")
    const splitTicketId = searchParams.get("splitTicketId")
    //Don't get this from the URL it could be a long list. Rather get it from State
    const selectedActions = useReduxSelector(state => state.selectedActionsStore.selectedActions);
    const splitActionIds = splitTicketId?.length && selectedActions?.filter(a => a.ticketId === parseInt(splitTicketId)).map(a => a.actionId).join(',') || null;
    //const splitActionIds = searchParams.get("splitActionIds")
    const navigate = useNavigate();
    const dispatch = useReduxDispatch();
    const { ticket, logOptions, formState, bulkLog, selectedForm } = useReduxSelector(state => state.newTicket);
    const { action: initialAction } = useReduxSelector(state => state.actionDetails);
    const { data: userProfile, isFetching: profileIsLoading } = Api.useGetUserProfileQuery();
    const { data: formData, isFetching: formIsLoading } = ProjectApi.useGetFormByProjectQuery({ projectId: ticket.Project_Id, companyId: ticket.Company_Id, locationId: ticket.Company_Address_Id }, { skip: !ticket.Project_Id })
    const { data: newTicketEndUser, isFetching: userLoading } = UserApi.useGetUserQuery(ticket.Company_Contact_Uid, { skip: !ticket.Company_Contact_Uid })
    const { data: existingTicket, isFetching: ticketIsLoading } = TicketApi.useGetTicketQuery({ ticketId: parseInt(ticketId), populateFormData: true }, { skip: isNaN(parseInt(ticketId)) });
    const { data: assContactConfig } = Api.useGetAssContactConfigQuery(ticket.Company_Type_Id, { skip: !ticket.Company_Type_Id });
    const { data: customFormConfig } = ProjectApi.useGetFormConfigQuery();
    const { data: selectedProject, isFetching: projectIsLoading } = ProjectApi.useGetProjectQuery(ticket.Project_Id, { skip: !ticket.Project_Id });
    const { data: defaultProjectAssignment, isFetching: defAssignmentLoading } = ProjectApi.useGetProjectAssignmentQuery(ticket.Project_Id, { skip: !ticket.Project_Id });
    const { data: selectedPriority } = Api.useGetPriorityQuery(ticket.Priority_Id, { skip: !ticket.Priority_Id });
    const { data: slas } = ProjectApi.useGetSLAListQuery({ projectId: ticket.Project_Id, priorityId: ticket.Priority_Id });
    const { data: quickNote } = TicketApi.useGetQuickNoteAsActionQuery({ id: initialAction?.Quick_Note_Id, ticketId: 0 }, { skip: !initialAction?.Quick_Note_Id })
    const { data: statuses } = TicketApi.useGetStatusesQuery();
    const { data: priorities } = TicketApi.useGetPriorityListQuery(selectedProject?.Priority_Set_Id, { skip: !selectedProject?.Priority_Set_Id });
    const { data: typesList } = TicketApi.useGetMyTypeListQuery(-1)
    //const requiredStyle = { background: `#${userProfile.Nav_Hex_Color}`, color: '#fff' }
    const [quickNoteId, setQuickNoteId] = React.useState(initialAction?.Quick_Note_Id);
    const quickNoteStatus = statuses?.find(s => s.ID === quickNote?.Quick_Note_Status_Id)
    const quickNotePriority = priorities?.find(s => s.ID === quickNote?.Quick_Note_Priority_Id)

    const selectedSLA = slas?.find(s => s.SLA_ID === ticket.SLA_Id);
    const timelineTitle = `Timeline ${selectedSLA?.SLA_ID > 0 ? '- ' + selectedSLA.SLA_Code + `(${selectedSLA.SLA_Response_Time}/${selectedSLA.SLA_Resolve_Time})` : '- No SLA'}`

    //Save Ticket endpoint
    const [postTicket, { isLoading: savingTicket, error: saveTicketError }] = TicketApi.useCreateTicketMutation();
    const [bulkLogTicket, { isLoading: savingBulkTicket, error: bulkSaveTicketError }] = TicketApi.useBulkLogTicketMutation();
    const somethingLoading = profileIsLoading || formIsLoading || ticketIsLoading || projectIsLoading || savingTicket || savingBulkTicket || userLoading || defAssignmentLoading

    //Grab the templateID from the querystring and shove it in the Slice
    useEffect(() => {
        //console.log('Checking templates', templateId, template);

        if (ticket.Template_Id !== parseInt(templateId) && !isNaN(parseInt(templateId))) {
            //console.log('SetTemplate:', templateId)
            dispatch(TicketSlice.SetTemplate({ Id: parseInt(templateId) } as ITemplateListItem))
        }
    }, [dispatch, templateId, ticket.Template_Id])

    //Load the user from Querystring
    useEffect(() => { endUserUId && dispatch(TicketSlice.SetEndUserUid(endUserUId)) }, [dispatch, endUserUId])
    //Load the Parent Ticket ID from Querystring
    useEffect(() => { parentCallId && dispatch(TicketSlice.SetHierarchy({ Parent_Ticket_Id: parseInt(parentCallId), IsParent: false })) }, [dispatch, parentCallId])
    //Load SPlitOptions
    useEffect(() => { splitActionIds && splitTicketId && dispatch(TicketSlice.SetSplitOptions({ TicketId: parseInt(splitTicketId), Ids: splitActionIds.split(",").map(a => parseInt(a)) })) }, [dispatch, splitActionIds, splitTicketId])

    //Load Contact Details into the ticket
    useEffect(() => {
        //console.log('useEffect SetEndUser', ticket?.Company_Contact_Uid, newTicketEndUser?.ID, newTicketEndUser?.UId)
        if (ticket?.Company_Contact_Uid && newTicketEndUser && newTicketEndUser?.UId === ticket?.Company_Contact_Uid) {
            console.log('useEffect SetEndUser', ticket?.Company_Contact_Uid, newTicketEndUser?.ID, newTicketEndUser?.UId)
            //ticket?.Company_Contact_Uid !== newTicketEndUser?.UId && 
            dispatch(TicketSlice.SetEndUser(newTicketEndUser))

            //Don't overwrite UserFynd Selection
            if (ticket.Contact_Name.indexOf(newTicketEndUser?.FullName) === -1)
                dispatch(TicketSlice.SetEndUserName(newTicketEndUser?.FullName))
        }

    }, [dispatch, newTicketEndUser, ticket?.Company_Contact_Uid])

    //Update the form fields of the ticket when then project changes
    useEffect(() => { !existingTicket && dispatch(TicketSlice.SetForm(formData)) }, [dispatch, existingTicket, formData])

    //Load the existing ticket
    useEffect(() => {
        if (existingTicket) {
            dispatch(TicketSlice.SetTicket(existingTicket))
        }
        else if (!ticketId && ticket?.ID) {
            //console.log('!ticketId && ticket?.ID',!ticketId,ticket?.ID)
            dispatch(TicketSlice.ResetTicket(null));
            dispatch(ActionSlice.ResetAction(null));
        }
    }, [dispatch, existingTicket, ticket, ticketId])

    //Listen for when a quick note is changed
    useEffect(() => {
        if (quickNote && quickNoteId !== quickNote.Quick_Note_Id) {
            console.log('Listen for when a quick note is changed', quickNote, quickNoteStatus, quickNotePriority)
            //Type
            if (quickNote.Quick_Note_Type_Id) { dispatch(TicketSlice.SetType(quickNote.Quick_Note_Type_Id)) }

            //Status
            if (quickNote.Quick_Note_Status_Id && quickNoteStatus) { dispatch(TicketSlice.SetStatus(quickNoteStatus)) }

            //Priority
            if (quickNote.Quick_Note_Priority_Id && quickNotePriority) { dispatch(TicketSlice.SetPriority(quickNotePriority)) }

            setQuickNoteId(quickNote.Quick_Note_Id);
        }
    }, [dispatch, quickNote, quickNoteId, quickNoteStatus, quickNotePriority])

    //Update the call assignees whenever the project chnages
    useEffect(() => {
        if (!userProfile?.Features.Project_Default_Assignment) return;

        if (ticket.Project_Id > 0 && defaultProjectAssignment) {
            const assignedStaff = defaultProjectAssignment?.map<IStaff>(ass => { return { Full_Name: ass.Contact_Name, ID: ass.Contact_Id } as IStaff });
            dispatch(TicketSlice.SetAssigned(assignedStaff))
        }
    }, [ticket.Project_Id, defaultProjectAssignment, dispatch, userProfile])

    //Client Change Handler
    const clientChangeHandler = (e: DropDownListChangeEvent) => {
        console.log('clientChangeHandler value', e.value);
        //Reset end user
        dispatch(TicketSlice.SetEndUserUid(null))
        dispatch(TicketSlice.SetEndUserName(""))
        dispatch(TicketSlice.SetEndUser(null))
        dispatch(TicketSlice.SetProject(null))
        dispatch(TicketSlice.SetForm(null))
        dispatch(TicketSlice.SetClient((e.value as IClient).ID))

    }

    //Change Handlers
    const endUserChangeHandler = (e: IFyndResult) => {

        if (e) {
            if (bulkLog) {
                console.log('Set bulk contacts', e)
                let newArray = [...ticket?.Bulk_Contact_Ids]
                newArray.push(e.Contact_Id)
                dispatch(TicketSlice.SetBulkContacts(newArray.map(g => { return { ID: g } as IStaff })));

            } else {
                console.log('SetEndUserUid', e?.Contact_Name, e?.Contact_Id);
                dispatch(TicketSlice.SetEndUserUid(e?.UId));
                e?.Contact_Name && dispatch(TicketSlice.SetEndUserName(e?.Contact_Name?.replaceAll("<em>", "")?.replaceAll("</em>", "")));

                if (e.Asset_Id)
                    dispatch(TicketSlice.SetAssets([{ Asset_Id: e.Asset_Id, Call_Id: 0, Contact_Id: e.Contact_Id }]))
                else
                    dispatch(TicketSlice.SetAssets([])) //Clear existing
            }
        }
        else {
            //Removed
            dispatch(TicketSlice.SetEndUserUid(null))
            dispatch(TicketSlice.SetEndUserName(""))
            dispatch(TicketSlice.SetEndUser(null))
            dispatch(TicketSlice.SetProject(null))
            dispatch(TicketSlice.SetForm(null))
        }

    }

    const dueDateChanged = (e) => dispatch(TicketSlice.SetDueDate(e.target.value))
    const projectChangeHandler = (project: IProject) => dispatch(TicketSlice.SetProject(project));
    const priorityChangeHandler = (e) => dispatch(TicketSlice.SetPriority(e.target.value));
    const teamChangeHandler = (e) => dispatch(TicketSlice.SetTeam(e.target.value));
    const slaChangeHandler = (e) => dispatch(TicketSlice.SetSLA(e.value));
    const typeChanged = (e) => dispatch(TicketSlice.SetType(e.id))
    const fieldChanged = (e) => {
        console.log('fieldChanged in TicketDetails', e)
        dispatch(TicketSlice.SetField(e.value));

    }
    // const descriptionChanged = (e) => dispatch(TicketSlice.SetDescription(e.target.value));
    const assignedChangeHandler = (e) => dispatch(TicketSlice.SetAssigned(e.value));
    const associatedChangeHandler = (e) => { dispatch(TicketSlice.SetAssociatedContacts(e.value)) }
    const bulkChangeHandler = (e) => { dispatch(TicketSlice.SetAssociatedContacts(e.value)) }

    const handleSubmit = (dataItem) => {

        console.log('handleSubmit started ')

        //Remove any blank actions
        //initialAction?.HTML_Notes?.length && ticket.MergeActionsFromCallId.
        let saveTicket = { ...ticket, Actions: initialAction?.HTML_Notes?.length ? [initialAction] : undefined }
        let saveMethod = saveTicket.Bulk_Contact_Ids?.length ? bulkLogTicket : postTicket;

        console.log('handleSubmit', saveMethod, saveTicket)

        //Submit the ticket to the API.
        saveMethod(saveTicket).unwrap().then(result => {
            console.log("ID in result", "ID" in (result as object))
            console.log("result is Array", Array.isArray(result))
            let newTicketIds = Array.isArray(result) ? result.map(r => r.ID) : [(result as ITicket).ID]
            //Raise event
            const raiseTicketSaved = () => {
                props.ticketSaved(newTicketIds);
            }

            let myOptions = logOptions?.Options?.split(',').filter(l => l !== '');
            let viewDetailsURL = `/ticket/${newTicketIds[0]}`;
            console.log('log options?', myOptions, viewDetailsURL)
            let viewTicketDetails = () => {
                //Reset the form and go to details
                ResetForm();
                navigate(viewDetailsURL);
            }
            if (!myOptions || myOptions.length === 0 || (myOptions.length === 1 && (myOptions.indexOf('1') > -1 || myOptions.indexOf('2') > -1))) {
                console.log('No log options or PIN only')
                setConfirmDialogProps((currentProps) => {
                    return {
                        ...currentProps, visible: true, ticketIds: newTicketIds, title: userProfile.Phrases.CallPhrase + ' logged', viewDetails: viewTicketDetails, toggleDialog: () => {
                            //reset this form
                            ResetForm();
                            //GoBack to previous page (TicketPage.tsx)
                            raiseTicketSaved();
                        }
                    }
                });
            } else if (myOptions.indexOf('3') > -1) {
                console.log('Log another (Blank)')
                setConfirmDialogProps((currentProps) => { return { ...currentProps, visible: true, ticketIds: newTicketIds, title: userProfile.Phrases.CallPhrase + ' logged', viewDetails: viewTicketDetails } });
                //Log another (Blank)
                ResetForm();
            } else if (myOptions.indexOf('4') > -1) {
                console.log('Log another (Duplicate)')
                setConfirmDialogProps((currentProps) => { return { ...currentProps, visible: true, ticketIds: newTicketIds, title: userProfile.Phrases.CallPhrase + ' logged', viewDetails: viewTicketDetails } });
                //Log another (Duplicate)
                //Do nothing
            } else {
                if (myOptions.indexOf('0') > -1) { //view details
                    //reset this form
                    ResetForm();
                    //GoBack to previous page (TicketPage.tsx)
                    raiseTicketSaved();
                }
            }
        }).catch((e) => {
            //Probably a validation error
            //console.error('caught', e)
            if (e.originalStatus === 400) {
                //Show validation message
                //navigate('#ticket-form');
                if (divErrorRef?.current)
                    divErrorRef.current.scrollIntoView({ behavior: "smooth" });
            }
        });
    }
    const divErrorRef = useRef<HTMLDivElement>();
    const ResetForm = () => {
        console.log('ResetForm')
        dispatch(TicketSlice.ResetTicket(null));
        dispatch(ActionSlice.ResetAction(null));
        dispatch(FileSlice.ResetFiles(null));
    }

    const formValidator = (values) => {
        const closeTicketValidation = ticket.Open_Status === 0 || ticket.Open_Status === 4 || ticket.LogOptions?.Close;
        let customFieldValidators = { ...validateCustomFields(ticket.CustomFormFields, closeTicketValidation) }
        let formValidator = Object.keys(customFieldValidators).length ? { "customform": `${Object.keys(customFieldValidators).length} ${Object.keys(customFieldValidators).length === 1 ? 'field' : 'fields'} required` } : {};
        let typeRequired = userProfile?.Features?.Call_Types && (typesList?.length > 0) && !ticket.Type_Id && (userProfile?.Features?.Ticket_Type_Required_To_Log || (closeTicketValidation && userProfile.Features.Ticket_Type_Required_To_Close))
        let actionRequired = closeTicketValidation && !initialAction.HTML_Notes

        let val = {
            ...(!ticket.Call_Desc?.trim()?.length && { "description": `${userProfile?.Phrases.Description} is required` }),
            ...(!ticket.Project_Id && !bulkLog && { "project": ` (required)` }),
            ...(!ticket.Company_Contact && !bulkLog && { "endUser": ` (required)` }),
            ...(typeRequired && { "type": ` (required)` }),
            ...(actionRequired && { "action": ` (required)` }),
            ...(ticket.Is_Workstream && !ticket.WorkstreamId && { "workstream": ` (required)` }),
            ...(ticket.Is_Workstream && !ticket.Start_Date && { "workstreamStart": ` (required)` }),
            ...(ticket.Is_Workstream && !ticket.End_Date && { "workstreamEnd": ` (required)` }),
            ...(ticket.Is_Workstream && ticket.End_Date && ticket.End_Date < ticket.Start_Date && { "workstreamEnd": ` (End date must be greater than the start date)` }),
            ...(ticket.Is_Workstream && ticket.Workstream_Assignment?.reduce((a, b) => a + parseInt(b.Assigned_Percent.toString()), 0) !== 100 && { "workstreamAssignment": ` (Total assigned percent is ${ticket.Workstream_Assignment?.reduce((a, b) => a + b.Assigned_Percent, 0) || 0}% but it must total 100%) ` }),
            ...customFieldValidators,
            ...formValidator
        }


        //if (ticket.Call_Desc && ticket.Project_Id && (ticket.Company_Contact || bulkLog) && !actionRequired && !typeRequired && !Object.keys(customFieldValidators).length) {
        if (Object.keys(val).length) {
            const pageVal = {
                ...val,
                ...((val.type || val.project || val.endUser) && { "top": ` (required)` }),
                VALIDATION_SUMMARY: "Please fill in all required fields below.",
            }
            // console.log('not good', pageVal)

            return pageVal;//NOT good
        }
        //console.log('formValidator', val, Object.keys(val).length)

        return {}; //All Good
    };

    //const descValidator = (value) => { return ticket?.Call_Desc ? "" : userProfile?.Phrases.Description + " is required." };
    const wrapper2 = useRef(null);
    const customFormTop = ticket?.CustomFormId && ticket?.CustomFormId !== -1 && customFormConfig?.Custom_Forms_Enabled && customFormConfig?.Log_Call_Orientation === 1
    const customFormBottom = ticket?.CustomFormId && ticket?.CustomFormId !== -1 && customFormConfig?.Custom_Forms_Enabled && !customFormConfig?.Log_Call_Orientation
    const handleSelect = (e: PanelBarSelectEventArguments) => {
        //console.log('handleSelect', e)
        dispatch(TicketSlice.SetFormState(e.expandedItems))

        //post to persist settings in API.
        //saveLogOptions(logOptions);
    };
    const toggleBulkLogging = () => {
        dispatch(TicketSlice.SetBulkLog(!bulkLog))
    }
    const filterClicked = () => {
        let newState = [...formState]
        if (newState.indexOf('client-type-filter') > -1)
            newState.splice(newState.indexOf('client-type-filter'), 1)
        else
            newState.push('client-type-filter')
        dispatch(TicketSlice.SetFormState(newState))
    };

    const requiredStyleClass = `
    #ticket-form-nope .k-messagebox-error,
    #ticket-form .k-panelbar-header.section-required>span.k-link .k-panelbar-item-icon,
    #ticket-form .k-panelbar>.k-panelbar-header.section-required>span.k-link,
    #ticket-form .k-panelbar>.k-panelbar-header.section-required>span.k-link.k-selected,
    #ticket-form .k-panelbar>.k-panelbar-header.section-required>span.k-link.k-selected:hover,
    #ticket-form .k-panelbar>.k-panelbar-header.section-required>span.k-link:hover {
        border-color: ${userProfile?.Nav_Hex_Color};
        color: #fff;
        background-color: ${userProfile?.Nav_Hex_Color};
    }
    #ticket-form .k-form-error,
    #ticket-form .k-text-error{
        color: ${userProfile?.Nav_Hex_Color};    
    }
    #ticket-form .k-picker-solid.k-invalid, 
    #ticket-form .k-picker-solid.ng-invalid.ng-touched, 
    #ticket-form .k-picker-solid.ng-invalid.ng-dirty{
        border-color: ${userProfile?.Nav_Hex_Color};    
    }
    `;


    return (
        <>
            {/* {/* Success dialog */}
            {confirmDialogProps.visible && <TicketSavedDialog toggleDialog={() => setConfirmDialogProps({ ...confirmDialogProps, visible: false })} {...confirmDialogProps} />}
            <Form onSubmit={handleSubmit} validator={formValidator} ignoreModified={true} id='ticket-form'
                initialValues={{
                    due: ticket?.Due_Dt ? new Date(ticket?.Due_Dt + 'Z') : undefined,
                }}
                render={(formRenderProps) => {
                    // const DescContainerProps: ITicketPanelBarItemProps = {
                    //     className: formRenderProps.errors.description ? SECTION_REQUIRED : null,
                    //     id: DESCRIPTION_LOWERCASE,
                    //     title: userProfile ? userProfile.Phrases.Description : ""
                    // }

                    return (
                        <FormElement>
                            {/* formRenderProps:{JSON.stringify(formRenderProps)} */}
                            <div id='error-summary' ref={divErrorRef}>
                                {/* Validation */}
                                {saveTicketError?.["data"] && saveTicketError?.["data"] && (
                                    <div className={"k-messagebox k-messagebox-error"}>
                                        {saveTicketError["data"]?.Message || saveTicketError["data"]}
                                    </div>)}
                                {bulkSaveTicketError?.["data"] && (
                                    <div className={"k-messagebox k-messagebox-error"}>
                                        An unexpected application error occurred:&nbsp;
                                        {bulkSaveTicketError["data"]?.Message || bulkSaveTicketError["data"]}
                                    </div>)}
                                {formRenderProps.errors &&
                                    formRenderProps.errors.VALIDATION_SUMMARY && (
                                        <div className={"k-messagebox k-messagebox-error"}>
                                            {formRenderProps.errors.VALIDATION_SUMMARY}
                                        </div>
                                    )}

                            </div>
                            <div className='new-ticket '>
                                <PanelBar isControlled={true} expanded={Object.assign([], formState)} onSelect={handleSelect}>
                                    <PanelBarItem id="details" selected={true} title='Details' icon='user' className={formRenderProps.errors.top ? SECTION_REQUIRED : null} >
                                        <div>
                                            {userProfile?.Features.Show_Client_Type_Filter && formState.indexOf('client-type-filter') > -1 &&
                                                <div>
                                                    <Field
                                                        id={"clientTypeFilter"}
                                                        name={"clientTypeFilter"}
                                                        component={ClientTypeFilter}
                                                    />
                                                </div>}
                                            <div>
                                                <div className='inline-block w-full'>

                                                    <Field
                                                        id={"endUser"}
                                                        name={"endUser"}
                                                        label={userProfile?.Phrases.EndUser + (bulkLog ? 's' : '')}
                                                        component={UserFynd}
                                                        onChange={endUserChangeHandler}
                                                        onClientChange={clientChangeHandler}
                                                        display={ticket.Contact_Name}
                                                        companyId={ticket.Company_Id}
                                                        endUserId={ticket.Company_Contact}
                                                        filterClicked={filterClicked}
                                                        toggleBulkLogging={toggleBulkLogging}
                                                        bulkContactIds={ticket.Bulk_Contact_Ids}
                                                    />

                                                </div>
                                                <FlaggedNotes ticket={ticket} showPopup={true} />
                                            </div>
                                            {bulkLog &&
                                                <div>
                                                    <Field
                                                        id={"bulkContacts"}
                                                        name={"bulkContacts"}
                                                        component={BulkContacts}
                                                        bulkContactIds={ticket.Bulk_Contact_Ids}
                                                        onChange={bulkChangeHandler} />
                                                </div>
                                            }
                                            {assContactConfig?.IsActive &&
                                                <div>
                                                    <Field
                                                        id={"assContacts"}
                                                        name={"assContacts"}
                                                        label={`Associated ${userProfile?.Phrases.Contact}s`}
                                                        component={AssociatedContacts}
                                                        companyTypeId={ticket.Company_Type_Id}
                                                        companyId={ticket.Company_Id}
                                                        ticketId={ticket.ID}
                                                        locationId={ticket.Company_Address_Id}
                                                        assContactIds={ticket.Associated_Contact_Ids}
                                                        onChange={associatedChangeHandler}
                                                    />
                                                </div>
                                            }
                                            <div className='flex w-full '>
                                                <div className='inline-block w-full'>
                                                    <Field
                                                        id={"project"}
                                                        name={"project"}
                                                        label={userProfile?.Phrases.Project}
                                                        component={ProjectList}
                                                        companyId={ticket.Company_Id}
                                                        selectedProject={ticket?.Project_Id ? selectedProject : null}
                                                        onSelect={projectChangeHandler} />
                                                </div>
                                            </div>
                                            <div className='flex flex-wrap w-full'>
                                                <div className='inline-block w-full sm:w-1/2 sm:pr-3'>
                                                    <Field
                                                        id={"status"}
                                                        name={"status"}
                                                        label={"Status"}
                                                        component={StatusList}
                                                        statusId={ticket?.Call_Status_Id}
                                                        autoCloseSettings={ticket?.AutoCloseSettings}
                                                        autoOpenSettings={ticket?.AutoOpenSettings}
                                                        onChange={(e) => {
                                                            //Set the ticket status
                                                            dispatch(TicketSlice.SetStatus(e.value.status));
                                                            //And possibly the auto close settings
                                                            dispatch(TicketSlice.SetAutoCloseSetting(e.value.autoCloseSettings))
                                                            //Auto reopen from on-hold
                                                            dispatch(TicketSlice.SetAutoOpenSetting(e.value.autoOpenSettings))
                                                        }
                                                        } />
                                                </div>
                                                {userProfile?.Features.Call_Types && <div className='inline-block w-full sm:w-1/2 pl-0'>
                                                    <Field
                                                        id={"type"}
                                                        name={"type"}
                                                        label={userProfile?.Phrases.Type}
                                                        component={TypeList}
                                                        typeId={ticket?.Type_Id}
                                                        onChange={typeChanged} />
                                                </div>}
                                            </div>
                                            <div>
                                                {userProfile?.Features.Show_Team_Filter && (
                                                    <div className='inline-block w-full sm:w-1/2 sm:pr-3'>
                                                        <Field
                                                            id={"team"}
                                                            name={"team"}
                                                            label={userProfile?.Phrases.Team}
                                                            component={TeamList}
                                                            onChange={teamChangeHandler}
                                                            teamId={ticket?.Assigned_Team_Id}
                                                        />
                                                    </div>)}
                                                <div className={userProfile?.Features.Show_Team_Filter ? 'inline-block w-full sm:w-1/2' : 'inline-block w-full'} ref={wrapper2}>
                                                    {ticket.Is_Workstream ?
                                                        <Field
                                                            id={"workstreamAssignment"}
                                                            name={"workstreamAssignment"}
                                                            label={"Assigned To"}
                                                            projectId={ticket?.Project_Id}
                                                            teamId={ticket?.Assigned_Team_Id}
                                                            component={WorkstreamAssignment}
                                                            staff={ticket?.Workstream_Assignment}
                                                            effort={ticket?.Effort_Mins}
                                                            assignmentChanged={(e) => {
                                                                console.log('assignmentChanged in TicketDetails', e.value);
                                                                dispatch(TicketSlice.SetWorkstreamAssignment(e.value));
                                                            }} />
                                                        :
                                                        <Field
                                                            id={"assigned"}
                                                            name={"assigned"}
                                                            label={"Assigned To:"}
                                                            showMe={true}
                                                            projectId={ticket?.Project_Id}
                                                            teamId={ticket?.Assigned_Team_Id}
                                                            staff={ticket?.Call_Assignment}
                                                            component={AssignedStaff}
                                                            onChange={assignedChangeHandler} />

                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </PanelBarItem>
                                    {!ticket?.Is_Workstream && <PanelBarItem id="timeline" title={timelineTitle} selected={true} icon='clock'>
                                        <div>
                                            {userProfile?.Features.Multi_SLA && (

                                                <div className='inline-block w-1/2 sm:pr-3'>
                                                    <Field
                                                        id={"sla"}
                                                        name={"sla"}
                                                        label={userProfile?.Phrases.SLA}
                                                        component={SLAList}
                                                        onChange={slaChangeHandler}
                                                        projectId={ticket?.Project_Id}
                                                        priorityId={ticket?.Priority_Id}
                                                        slaId={ticket?.SLA_Id} />
                                                </div>

                                            )}
                                            <div className='inline-block w-full sm:w-1/2 '>
                                                <Field
                                                    id={"priority"}
                                                    name={"priority"}
                                                    label={userProfile?.Phrases.Priority}
                                                    validationMessage={`${userProfile?.Phrases.Priority} is required`}
                                                    component={PriorityList}
                                                    prioritySetId={selectedProject?.Priority_Set_Id}
                                                    selectedPriority={selectedPriority}
                                                    priorityChangeHandler={priorityChangeHandler} />
                                            </div>
                                        </div>
                                        <div>
                                            <div className='inline-block w-full sm:w-1/2'>
                                                {ticket?.Due_Dt}
                                                <Field
                                                    id={"due"}
                                                    name={"due"}
                                                    label={"Due Date"}
                                                    onChange={dueDateChanged}
                                                    component={DateTimePicker}
                                                />

                                            </div>
                                            <div className='inline-block w-full sm:w-1/2 sm:pl-3'>
                                                <Label                            >
                                                    {"Timeline"}
                                                </Label>
                                                <TimelineImage {...ticket} />
                                            </div>
                                        </div>
                                    </PanelBarItem>}
                                    <PanelBarItem id="workstream-section" title={userProfile?.Phrases.Workstream || ""} selected={true} className={formRenderProps.errors.workstream || formRenderProps.errors.workstreamStart || formRenderProps.errors.workstreamEnd ? 'section-required' : (ticket?.Is_Workstream ? null : 'hidden')} icon='clock'>
                                        {ticket?.Is_Workstream && <TicketWorkstream
                                            selectedProject={ticket?.Project_Id ? selectedProject : null}
                                        />}
                                    </PanelBarItem>
                                    <PanelBarItem id="form" title={ticket?.CustomFormName + (formRenderProps.errors.customform ? ' - ' + formRenderProps.errors.customform : '')} className={customFormTop ? formRenderProps.errors.customform ? SECTION_REQUIRED : null : 'hidden'} icon='paste-plain-text'>
                                        {customFormTop && (<Field
                                            id={"customform"}
                                            name={"customform"}
                                            label={"form"}
                                            component={CustomFormControl}
                                            form={selectedForm}
                                            fields={ticket?.CustomFormFields}
                                            companyId={ticket.Company_Id}
                                            onChange={fieldChanged} />)}
                                    </PanelBarItem>
                                    <PanelBarItem id="description" title={userProfile?.Phrases.Description || ""} selected={true} className={formRenderProps.errors.description ? 'section-required' : null} icon='track-changes'>
                                        <TicketDescription />
                                    </PanelBarItem>
                                    <PanelBarItem id="form" focused={true} title={ticket?.CustomFormName + (formRenderProps.errors.customform ? ' - ' + formRenderProps.errors.customform : '')} selected={false} className={customFormBottom ? formRenderProps.errors.customform ? SECTION_REQUIRED : null : 'hidden'} icon='paste-plain-text'>
                                        {customFormBottom &&
                                            <Field
                                                id={"customform"}
                                                name={"customform"}
                                                label={"form"}
                                                component={CustomFormControl}
                                                form={selectedForm}
                                                fields={ticket?.CustomFormFields}
                                                companyId={ticket.Company_Id}
                                                onChange={fieldChanged} />}
                                    </PanelBarItem>
                                    <PanelBarItem id="action" parentExpanded={true} focused={true} title={`Add ${userProfile?.Phrases.Action}`} selected={false} className={formRenderProps.errors.action ? SECTION_REQUIRED : null} icon='comment'>
                                        <Field
                                            id={"action"}
                                            name={"action"}
                                            component={ActionNote}
                                            companyId={ticket?.Company_Id}
                                            statusId={ticket?.Call_Status_Id}
                                        />
                                    </PanelBarItem>
                                    {debug && <PanelBarItem id="meta" expanded={false} title='Meta data' selected={true}>
                                        <JsonTreeViewer data={ticket} title="Ticket data" />
                                        <JsonTreeViewer data={initialAction} title="Action data" />
                                    </PanelBarItem>}
                                </PanelBar>

                            </div>
                        </FormElement>

                    )
                }
                } />
            {somethingLoading && <PartialSpinny />}
        </>
    )
}
export default NewTicketDetails;